import React from 'react';
import './GapBar.scss';

export interface GapBarProps {
  visibilityPct: number;
  /** null = cited unknown (brand without known domains): only the visibility track is drawn. */
  citedPct: number | null;
}

/**
 * The stacked visibility/cited bars of the Insights tab, shared by PlatformGapBars and
 * CompetitorComparison: two 6px tracks one under the other — visibility on TOP, cited BELOW — so the
 * fills never cover each other. Colors are the section tokens (visibility soft primary-200, cited
 * green-100); the matching footer legend is `GapLegend`.
 */
export const GapBar: React.FC<GapBarProps> = ({ visibilityPct, citedPct }) => (
  <span className="gap-bar">
    <span className="gap-bar__track">
      <span
        className="gap-bar__fill gap-bar__fill--visibility"
        // Dynamic width — the one inline style the conventions allow.
        style={{ width: `${visibilityPct}%` }}
      />
    </span>
    {citedPct !== null && (
      <span className="gap-bar__track">
        <span className="gap-bar__fill gap-bar__fill--cited" style={{ width: `${citedPct}%` }} />
      </span>
    )}
  </span>
);

export default GapBar;
